import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name: 'keys',
    standalone: false
})
export class KeysPipe implements PipeTransform {
  transform(value,sorData?) : any {
    if(sorData != undefined && sorData["__tab_order"] != undefined){
      try{
        var keyAr = Object.keys(value);
        var cloneAr = [];
        for(let k in sorData["__tab_order"]){
          if(cloneAr[sorData["__tab_order"][k]] == undefined){
            cloneAr[sorData["__tab_order"][k]] = k;
            var index = keyAr.indexOf(k);
            if (index !== -1) {
              keyAr.splice(index, 1);
            }
           }
           cloneAr.filter(Boolean);//removing undefined elements
        }
        keyAr.filter(Boolean);//removing undefined elements
        if(keyAr.length){
          cloneAr.push(...keyAr);
        }
        console.log("cloneAr+++++++++++",cloneAr);
        return cloneAr;
      }catch(e){
        console.error(e);
        return this.defaultVal(value);
      }
     
    }
    return this.defaultVal(value);
  }

  defaultVal(value){

    if(!value) {
      return null;
    }
    var keys = Object.keys(value);
    if(value?.[keys[0]]?.["data"] != undefined && value[keys[0]]["data"]?.["order"] != undefined){
      var arr = [];
      for(let t in value){
          if(value[t]["data"] != undefined && value[t]["data"]["order"] != undefined && value[t]["data"]["id"] != undefined){
            if(arr[value[t]["data"]["order"]] == undefined){
              arr[value[t]["data"]["order"]] = value[t]["data"]["id"];
            }else{
              arr.push(value[t]["data"]["id"]);
            }            
          }else{
            continue;
          }
      }
      return arr.filter(n => n)
    }
    return Object.keys(value);
  }

  assignIndex(cloneAr,k,index){
   
  }
}